import { phonesign } from '@/utils/tool';

export const columns = [
  {
    title: '姓名',
    dataIndex: 'name',
  },
  {
    title: '号码',
    dataIndex: 'phone_number',
    customRender: (text) => {
      return phonesign(text);
    },
  },
  {
    title: '操作',
    dataIndex: 'id',
    scopedSlots: { customRender: 'action' },
    width: 60,
  },
];
